import React from 'react';
import { Calendar } from 'lucide-react';
import { Event } from '../../../types';
import EventCard from './EventCard';

interface EventListProps {
  events: Event[];
  onEventClick: (event: Event) => void;
  selectedEventId: string | null;
  language: 'en' | 'ar';
  strings: any;
  getEventTypeName: (typeId: string) => string;
  getPlaceTypeName: (typeId: string) => string;
}

const EventList: React.FC<EventListProps> = ({
  events,
  onEventClick,
  selectedEventId,
  language,
  strings,
  getEventTypeName,
  getPlaceTypeName
}) => {
  if (events.length === 0) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
        <div className="p-12 text-center">
          <Calendar className="w-16 h-16 text-slate-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-600 dark:text-slate-400 mb-2">
            {language === 'ar' ? 'لا توجد أحداث' : 'No events found'}
          </h3>
          <p className="text-slate-500 dark:text-slate-500">
            {language === 'ar' ? 'لم يتم العثور على أي أحداث بعد.' : 'No events have been found yet.'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {events.map((event) => (
        <div
          key={event.id}
          onClick={() => onEventClick(event)}
          className={`cursor-pointer transition-all duration-200 ${
            selectedEventId === event.id
              ? 'ring-2 ring-primary ring-opacity-50'
              : 'hover:shadow-md'
          }`}
        >
          <EventCard
            event={event}
            language={language}
            strings={strings}
            getEventTypeName={getEventTypeName}
            getPlaceTypeName={getPlaceTypeName}
          />
        </div>
      ))}
    </div>
  );
};

export default EventList;
